// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2314":"475a977c","2606":"1a5da345","3323":"2f342a0c","7593":"9499d9c1","8312":"6ffe0ec7","9415":"6ffe0ec7","9625":"96314ca9"}[chunkId] + ".chunk.css";
};